import { Component, computed, inject, signal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { TieredMenu } from 'primeng/tieredmenu';

@Component({
  standalone: true,
  selector: 'app-move-to-organization-dialog',
  imports: [Button, TieredMenu],
  template: `
    <div class="p-1 flex flex-col gap-4">
      <p-tieredMenu [model]="menuItems()"></p-tieredMenu>

      <div class="flex justify-end gap-3 mt-4">
        <p-button
          label="Anuluj"
          styleClass="customInfoButton"
          (click)="ref.close()"
        ></p-button>

        <p-button
          label="Przenieś wniosek"
          styleClass="customInfoButton outlined"
          [disabled]="!selected()"
          (click)="submitMoveToOrganization()"
        />
      </div>
    </div>
  `,
})
export class MoveToOrganizationDialogComponent {
  protected readonly selected = signal<string | null>(null);
  readonly ref = inject(DynamicDialogRef);
  readonly cfg = inject(DynamicDialogConfig);
  readonly organizations = signal(this.cfg.data.organizations);
  readonly menuItems = computed(() =>
    this.organizations().map((org: any) => ({
      label: org.nazwa,
      command: () => this.#onSelect(org),
    })),
  );

  protected submitMoveToOrganization(): void {
    if (this.selected()) {
      this.ref.close(this.selected());
    }
  }

  #onSelect(org: any): void {
    this.selected.set(org.id);
  }
}
